import React from 'react';
import './App.css';
import { ThemeProvider } from './hooks/useTheme';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import RegistryBrowser from './pages/RegistryBrowser';
import ProjectsPage from './pages/ProjectsPage';
import AssistantHomePage from './pages/AssistantHomePage';
import ProjectSettingsPage from './pages/ProjectSettingsPage';
import ProjectDetails from './pages/ProjectDetails';
import EditorPage from './pages/EditorPage';
import Profile from './pages/Profile';
import KubernetesDiscoveryDashboard from './pages/KubernetesDiscoveryDashboard';
import BackendStatusIndicator from './components/BackendStatusIndicator';
import SystemHealthHeatmap from './pages/SystemHealthHeatmap';
import BcmBoardPage from './pages/BcmBoardPage';
import AdminPage from './pages/admin/AdminPage';
import { AuthProvider } from './context/AuthContext';
import { ProjectProvider } from './context/ProjectContext';
import LoginPage from './components/auth/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthCallback from './pages/AuthCallback';
import SessionExpiredModal from './components/SessionExpiredModal';
import { getHomeMode } from './utils/assistantPreferences';

const SystemsRedirect = () => {
  const { projectId } = useParams();
  return <Navigate to={`/projects/${projectId}/registry/information_systems`} replace />;
};

const HomePage = () => {
  return getHomeMode() === 'spaces' ? <ProjectsPage /> : <AssistantHomePage />;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ProjectProvider>
          <BrowserRouter>
            <SessionExpiredModal />
            <BackendStatusIndicator />
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<LoginPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/assistant" element={<AssistantHomePage />} />
                <Route path="/spaces" element={<ProjectsPage />} />
                <Route path="/projects/:projectId" element={<ProjectDetails />} />
                <Route path="/projects/:projectId/settings" element={<ProjectSettingsPage />} />
                <Route path="/projects/:projectId/registry/:slug" element={<RegistryBrowser />} />
                <Route path="/projects/:projectId/systems" element={<SystemsRedirect />} />
                <Route path="/projects/:projectId/health" element={<SystemHealthHeatmap />} />
                <Route path="/projects/:projectId/bcm" element={<BcmBoardPage />} />
                <Route path="/projects/:projectId/bcm/:mapEntryId" element={<BcmBoardPage />} />
                <Route path="/k8s-dashboard" element={<KubernetesDiscoveryDashboard />} />
                <Route path="/editor" element={<EditorPage />} />
                <Route path="/editor/:diagramId" element={<EditorPage />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </ProjectProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
